























import EquipmentCheckoutLoader from "@/components/equipment-checkout-loader.vue";
import {mapState} from 'vuex'

export default {
    name: "EquipmentCheckout",
    components: {EquipmentCheckoutLoader},
    computed: {
        ...mapState({
            globalRefresh: 'refresh'
        }),
        ...mapState('checkout', {
            checkouts: 'active',
            loading: 'loading',
        }),
        headers() {
            return [
                {text: 'to', value: 'to', class: 'title'},
                {text: 'checkout', value: 'out', class: 'title'},
                {text: 'what', value: 'resourceName', class: 'title'}
            ]


        }
    }
}
